import { type TTeamCheckerFlowProps } from '@capsicum/socios-core';

import { SelectFavouriteTeam } from '../../../partners/ui/select-favourite-team/SelectFavouriteTeam';

import { Wrapper } from './FavoriteTeamCheckerFlow.styled';

export const FavoriteTeamLoginCheckerFlow = ({ onProceed }: TTeamCheckerFlowProps) => {
	return (
		<Wrapper>
			<SelectFavouriteTeam layout="widget" onSkip={onProceed} onSubmit={onProceed} />
		</Wrapper>
	);
};
